export default __webpack_public_path__ + "static/media/illi8.a30897e6.png";